import React, { useState, useEffect } from "react";
import { Input, Pagination, Table, Button, Radio } from "antd";
import styles from "./index.module.css";
import {getProductList,removeProductList,getRegisterApproved,hideProduct,} from "../../api/register";
import { host } from "../../components/config";
import ProductDetail from "./productDetail";
import axios from "axios";
import UserInfoStore from "../../store/userInfoStore";
import { observer } from "mobx-react-lite";

const token = localStorage.getItem("token");

const RegisterList = () => {
  const userInfo = UserInfoStore.getUserInfo();
  //
  const [listData, setListData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageTotal, setPageTotal] = useState(0);

  const [selectionType, setSelectionType] = useState("checkbox");

  //详情
  const [productDetail, setProductDetail] = useState(null);
  const [registerId, setRegisterId] = useState("");

  useEffect(() => {
    if (userInfo.isManageUser) {
      getRegisterApproved({
        size: 10,
        page: page,
        hideFlag: 1,
        order: "createTime",
        sort: "desc",
      }).then((res) => {
        setListData(res.list || []);
        setPageTotal(res.total);
      });
    } else {
      getProductList({
        page: page,
        size: 10,
        order: "createTime",
        sort: "desc",
      }).then((res) => {
        setListData(res.list || []);
        setPageTotal(res.total);
      });
    }
  }, [page,userInfo.isManageUser]);

  //导出
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setRegisterId(selectedRowKeys);
    },
  };

  const exportProduct = () => {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      url: host + "info/export",
      data: {
        registerIds: registerId?registerId:[],
      },
      responseType: "blob",
    }).then((res) => {
      const content = res.data;
      const blob = new Blob([content]);
      const fileName = "导出数据.xls";
      const selfURL = window[window.webkitURL ? "webkitURL" : "URL"];
      let elink = document.createElement("a");
      if ("download" in elink) {
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = selfURL["createObjectURL"](blob);
        document.body.appendChild(elink);

        // 触发链接
        elink.click();
        selfURL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      } else {
        navigator.msSaveBlob(blob, fileName);
      }
    });
  };

  //显示或取消收藏作品
  const removeProduct = (id) => {
    if (userInfo.isManageUser) {
      hideProduct({
        registerId: id,
        hideFlag: 0,
      }).then((res) => {
        getRegisterApproved({
          size: 10,
          page: page,
          hideFlag: 1,
        }).then((res) => {
          setListData(res.list || []);
          setPageTotal(res.total);
        });
      });
    } else {
      removeProductList({
        registerId: id,
      }).then((res) => {
        getProductList({
          page: page,
          size: 10,
          order: "createTime",
          sort: "desc",
        }).then((res) => {
          setListData(res.list || []);
          setPageTotal(res.total);
        });
      });
    }
  };

  const columns = [
    {
      title: "登记号",
      dataIndex: "registerCertNumber",
      render: (text, record, index) => (
        <div >
          {record.registerCertNumber}
        </div>
      ),
    },
    {
      title: "作品名称",
      dataIndex: "productName",
      render: (text, record, index) => (
        <div >
          {record.productName}
        </div>
      ),
    },
    {
      title: "作品类别",
      dataIndex: "productCatName",
      render: (text, record, index) => (
        <div>
          {record.productCatName}
        </div>
      ),
    },
    {
      title: "作者",
      dataIndex: "authorsNames",
      render: (text, record, index) => (
        <div >
          {record.authorsNames}
        </div>
      ),
    },
    {
      title: "著作权人",
      dataIndex: "copyrightsNames",
      render: (text, record, index) => (
        <div >
          {record.copyrightsNames}
        </div>
      ),
    },
    {
      title: "作品详情",
      dataIndex: "productImage",
      render: (text, record, index) => (
        <Button
          onClick={() => setProductDetail(record)}
          type="primary"
          size="small"
        >
          查看
        </Button>
      ),
    },
    {
      title: "操作",
      render: (text, record, index) => (
        <Button
          onClick={() => removeProduct(record.registerId)}
          danger
          size="small"
        >
          {userInfo.isManageUser ? "显示作品" : "取消收藏"}
        </Button>
      ),
    },
  ];
  return (
    <div>
      {!userInfo.isManageUser ? (
        <div
          className={styles.topWrap}
          style={{
            border: "1px solid #eee",
            background: "#fafafa",
            marginTop: 20,
          }}
        >
          <Button onClick={() => exportProduct()}>导出</Button>
        </div>
      ) : <div  className={styles.topWrap}></div>}

      <Table
        rowSelection={{
          type: selectionType,
          ...rowSelection,
        }}
        dataSource={listData}
        columns={columns}
        bordered
        className={styles.tableWrap}
        rowKey={(record) => record.registerId}
        pagination={false}
      />
      <Pagination
        pageSize={10}
        current={page}
        onChange={(val) => setPage(val)}
        total={pageTotal}
        style={{
          textAlign: "center",
          padding: 50,
        }}
      />
      {productDetail && (
        <ProductDetail
          onCancel={() => setProductDetail(null)}
          productDetail={productDetail}
        />
      )}
    </div>
  );
};
export default observer(RegisterList);
